export default function ShopHero(){

return(

<section className="bg-[#F7F8F4] py-24">

<div className="max-w-7xl mx-auto px-6">

<p className="uppercase tracking-[4px] text-[#6B8E5F]">

Shop

</p>

<h1 className="mt-4 text-6xl font-semibold">

Curated Essentials

</h1>

<p className="mt-6 max-w-2xl text-lg text-gray-600">

Discover thoughtfully selected books,
coffee, apparel, accessories,
and living greens crafted for
intentional living.

</p>

</div>

</section>

)

}